import Vue from 'vue'
import VueRouter from 'vue-router'
const Login = () => import('../components/Login.vue')
const Home = () => import(/* webpackChunkName: "Home-Welcome" */ '../components/Home.vue')
const Welcome = () => import(/* webpackChunkName: "Home-Welcome" */ '../components/Welcome.vue')
const Users = () => import(/* webpackChunkName: "Users" */ '../components/user/Users.vue')
const Rights = () => import(/* webpackChunkName: "Rights" */ '../components/power/Rights.vue')
const Roles = () => import(/* webpackChunkName: "Roles" */ '../components/power/Roles.vue')
const Cate = () => import(/* webpackChunkName: "Cate" */ '../components/goods/Cate.vue')
const Params = () => import(/* webpackChunkName: "Params" */ '../components/goods/Params.vue')
const GoodsList = () => import(/* webpackChunkName: "List" */ '../components/goods/List.vue')
const GoodsDetail = () => import(/* webpackChunkName: "Detail" */ '../components/goods/Detail.vue')
const GoodsEdit = () => import(/* webpackChunkName: "Edit" */ '../components/goods/Edit.vue')
const GoodsAdd = () => import(/* webpackChunkName: "Add" */ '../components/goods/Add.vue')
const Order = () => import(/* webpackChunkName: "Order" */ '../components/order/Order.vue')
const Report = () => import(/* webpackChunkName: "Report" */ '../components/report/Report.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/home',
    component: Home,
    redirect: '/welcome',
    children: [
      { path: '/welcome', component: Welcome },
      { path: '/users', component: Users },
      { path: '/roles', component: Roles },
      { path: '/rights', component: Rights },
      { path: '/categories', component: Cate },
      { path: '/params', component: Params },
      { path: '/goods', component: GoodsList },
      { path: '/goods/detail', component: GoodsDetail },
      { path: '/goods/edit', component: GoodsEdit },
      { path: '/goods/add', component: GoodsAdd },
      { path: '/orders', component: Order },
      { path: '/reports', component: Report },
    ]
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next();
  const tokenStr = window.sessionStorage.getItem('vue_shop_admin-token');
  if (tokenStr) return next();
  next('/login');
});

export default router
